import { useEffect, useRef } from 'react';
import './MyNewsTabs.css';

export function MyNewsTabs({ tabs, activeTab, onSelect, onAdd, panelIdFor }) {
  const listRef = useRef(null);

  // The tab list scrolls; a swipe on the feed can activate a tab that is
  // out of view, so keep the active one visible however it was selected.
  useEffect(() => {
    listRef.current
      ?.querySelector('[aria-selected="true"]')
      ?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }, [activeTab]);

  return (
    <div className="my-news-tabs">
      <div
        className="my-news-tabs__list"
        role="tablist"
        aria-label="My News feeds"
        ref={listRef}
      >
        {tabs.map((tab) => (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={tab === activeTab}
            aria-controls={panelIdFor(tab)}
            className={
              tab === activeTab
                ? 'my-news-tabs__tab my-news-tabs__tab--active'
                : 'my-news-tabs__tab'
            }
            onClick={() => onSelect(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <button
        type="button"
        className="my-news-tabs__add"
        onClick={onAdd}
        aria-label="Add to My News"
      >
        +
      </button>
    </div>
  );
}
